import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

export let startLTIFailedLogin = () => {
  const root = createRoot(document.getElementById('ltiFailedLoginApp'))
  root.render(<App />)
}
